import { NgModule } from '@angular/core';
import { PMStatusNum2statusNameDirective } from './pm-statusnum2statusname.directive';

@NgModule({
  imports: [

  ],
  declarations: [
    PMStatusNum2statusNameDirective
  ],
  exports: [
    PMStatusNum2statusNameDirective
  ]
})

export class PMStatusNum2StatusNameModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/pm-statusnum2statusname/pm-statusnum2statusname.module.ts